/** @format */
import { centToDecimal } from '@toucan/client/global/currency';
import { Product } from '@toucan/client/global/product';

/**
 * Calculates the totals of an array of products
 */

export function calculateTotal(items: Pick<Product, 'value'>[] = []): number {
    return centToDecimal(
        items.reduce((total, { value }) => {
            total += value ?? 0;
            return total;
        }, 0)
    );
}
